@if (image) {
<img [ratio]="1"
     class="w-12"
     [dfImage]="image"
     [minSize]="50"
     [maxSize]="200"
     [attr.alt]="product.label || ''">
}